import React, { Component } from 'react';
import LayoutPages from '../../Components/LayoutPages';
import {
    Row,
    Col,
    Spin
} from 'antd';
import './PerfilSimples.css';

import UserProvider from '../../js/userProvider';
import DataService from '../../Components/Data';
import DadosPerfil from '../../Components/DadosPerfil/DadosPerfil';

class PerfilSimples extends Component {

    constructor(props) {
        super(props);

        this.state = {
            buscando: false
        }

        this.dataService = new DataService();
        this.dadosProvider = UserProvider.getInstance();
    }

    componentWillMount() {
        /*console.log(this.props.location.search);
        
        var search = this.props.location.search;

        if(search.indexOf("&cdPessoa=") > -1 && search.indexOf("?cdFilial=") > -1){
            
            var pieces = search.split("&");
            this.dadosProvider.setCdFilial(pieces[0].replace("?cdFilial=", ""));
            this.dadosProvider.setCdPessoa(pieces[1].replace("cdPessoa=", ""));
        }*/

        /*var usuario = this.dadosProvider.getDadosUsuario();

        if (usuario == null) {
            Auth.logout();
            this.props.history.push('/login');
        }*/
        
    }    

    render() {

        return (

            <DadosPerfil props={this.props} />
        )
    }
}

export default PerfilSimples;


// WEBPACK FOOTER //
// ./src/Pages/PerfilSimples/PerfilSimples.js